import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let StarshipSizes = class StarshipSizes extends VuexModule {
    constructor() {
        super(...arguments);
        this.starshipSizes = [];
        this.cachedVersion = 0;
    }
    async fetchStarshipSizes() {
        const { data: starshipSizes, cachedVersion } = await fetchFromCache(this, 'starshipSizes', 'starshipBaseSize');
        return { starshipSizes, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['starshipSizes', 'cachedVersion'] })
], StarshipSizes.prototype, "fetchStarshipSizes", null);
StarshipSizes = __decorate([
    Module({ namespaced: true, name: 'starshipSizes' })
], StarshipSizes);
export default StarshipSizes;
